import _ from 'lodash'

/**
 * mixin for
 *  1 render title
 */
export default {
  props: {
    icon: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      children: [],
    }
  },
  computed: {
    hasActiveItem() {
      const has = _.some(this.children, child => {
        return child.active || child.hasActiveItem
      })
      return has
    },
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    addItem(item) {
      this.children.push(item)
    },
    removeItem(item) {
      _.remove(this.children, item)
    },
  },
}
